/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
export default {
	SET_CUSTOMERS(state, customers) {
		state.customers = customers;
	},
	REMOVE_RECORD(state, itemId) {
		const userIndex = state.customers.findIndex(u => u._id == itemId);
		state.customers.splice(userIndex, 1);
	},
	SET_TOTAL_CUSTOMERS(state, total) {
		state.total = total;
	},
	ADD_CUSTOMER(state, customer) {
		state.customers.unshift(customer);
	},
	UPDATE_CUSTOMER(state, customer) {
		const idx = state.customers.findIndex(t => t._id === customer._id);
		if (idx !== -1) {
			Object.assign(state.customers[idx], customer);
		}
	},
	SET_FILTERS(state, filters) {
		state.filters = filters;
	}
};
